<template>
  <b-col>
    <b-row>
      <b-col cols="12">
        <div
          class="d-flex justify-content-between align-items-center pt-50 mb-2"
        >
          <div>
            <h2 class="font-weight-bolder m-0">
              Departamentos
            </h2>
          </div>
          <div class="d-flex align-items-center">
            <div class="mr-2">
              <b-link :to="{ name: 'createDepartment' }">
                <b-button
                  variant="primary"
                  class="text-nowrap"
                >
                  {{ "Añadir nuevo departamento" }}
                </b-button>
              </b-link>
            </div>
            <span
              class="cursor-pointer"
              @click="toggleFilterSidebar"
            >
              <feather-icon
                icon="FilterIcon"
                size="20"
              />
            </span>
          </div>
        </div>
      </b-col>
      <b-col cols="12">
        <!-- Sidebar de filtros -->
        <filter-sidebar
          v-model="showFilterSidebar"
          :has-active-filters="hasActiveFilters"
          :active-filters="computedActiveFilters"
          @apply-filters="handleSearch"
          @clear-filters="clearFilters"
          @remove-filter="removeActiveFilter"
        >
          <!-- Slot de filtros -->
          <template #filters>
            <b-form-group
              label="Búsqueda"
              label-for="search-input"
            >
              <b-input-group class="input-group">
                <b-input-group-prepend is-text>
                  <feather-icon icon="SearchIcon" />
                </b-input-group-prepend>
                <b-form-input
                  id="search-input"
                  v-model="searchTerm"
                  type="text"
                  :placeholder="'Búsqueda'"
                  @keydown.enter.native="handleSearch"
                />
              </b-input-group>
            </b-form-group>
          </template>
        </filter-sidebar>
      </b-col>
    </b-row>
    <b-card no-body>
      <b-table
        hover
        responsive
        :items="items"
        :fields="columns"
      >
        <template #cell(active)="data">
          <b-badge
            v-if="data.item.active"
            variant="success"
          >
            Activo
          </b-badge>
          <b-badge
            v-else
            variant="danger"
          >
            Desactivado
          </b-badge>
        </template>
        <template #cell(actions)="data">
          <span
            class="cursor-pointer"
            @click.prevent="downloadItem(data.item.id, 'archivo-qr')"
          >
            <img
              src="/img/qr-code-solid.svg"
              alt="QR Code Icon"
            >
          </span>
          <span>
            <b-link
              :to="{ name: 'editDepartment', params: { id: data.item.id } }"
              class="d-inline-block px-50 text-dark"
            >
              <feather-icon icon="Edit2Icon" />
            </b-link>
            <span
              class="d-inline-block px-50 text-danger"
              @click="deleteDepartment(data.item.id, data.item.name)"
            >
              <feather-icon icon="TrashIcon" />
            </span>
          </span>
        </template>
      </b-table>
      <div
          v-if="(totalItems / pageLength) > 1"
          class="d-flex align-items-center justify-content-between mb-1 px-2"
      >
        <div class="d-flex align-items-center mb-0">
          <span class="text-nowrap"> {{ "Por página" }}: </span>
          <b-form-select
              v-model="pageLength"
              :options="pages"
              class="ml-50 mr-1"
              @input="handlePageChange"
          />
          <span class="text-nowrap"> {{ "Total" }}: {{ totalItems }}</span>
        </div>
        <div>
          <b-pagination
              v-model="currentPage"
              :total-rows="totalItems"
              :per-page="pageLength"
              first-number
              last-number
              align="right"
              prev-class="prev-item"
              next-class="next-item"
              class="mt-1 mb-0"
              @change="handleChangePage"
          >
            <template #prev-text>
              <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
              />
            </template>
            <template #next-text>
              <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
              />
            </template>
          </b-pagination>
        </div>
      </div>
    </b-card>
  </b-col>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import axios from 'axios'
import {
  BFormInput,
  BBadge,
  BLink,
  BButton,
  BCard,
  BTable,
  BCol,
  BRow,
  BInputGroup,
  BInputGroupPrepend,
  BFormGroup, BPagination, BFormSelect,
} from 'bootstrap-vue'
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'
import { config } from '@/shared/app.config'
import FilterSidebar from '@/components/ui/FilterSidebar.vue'

export default {
  components: {
    BFormSelect,
    BPagination,
    BCard,
    BFormInput,
    BBadge,
    BTable,
    BButton,
    BCol,
    BRow,
    BLink,
    BInputGroup,
    BInputGroupPrepend,
    BFormGroup,
    FilterSidebar,
  },
  data() {
    return {
      columns: [
        {
          label: 'Nombre',
          key: 'name',
        },
        {
          label: 'Estado',
          key: 'active',
        },
        {
          label: 'Acciones',
          key: 'actions',
          class: 'column-actions',
        },
      ],
      searchTerm: '',
      appliedSearchTerm: '',
      showFilterSidebar: false,
      currentPage: 1,
      pageLength: 15,
      pages: [15, 25, 50],
    }
  },
  computed: {
    ...mapGetters({
      items: 'departments/getItems',
      totalItems: 'departments/getTotalItems',
      currentClient: 'clients/getCurrentClient',
    }),
    hasActiveFilters() {
      return this.appliedSearchTerm !== ''
    },
    computedActiveFilters() {
      const filters = []
      if (this.appliedSearchTerm) {
        filters.push({
          label: 'Búsqueda',
          value: this.appliedSearchTerm,
          icon: 'SearchIcon',
          filterType: 'search',
        })
      }
      return filters
    },
  },
  created() {
    this.chargeData()
  },
  methods: {
    ...mapActions({
      list: 'departments/getListDepartments',
      delete: 'departments/delete',
    }),
    downloadItem(url, label) {
      axios.get(`${config.webApiBase}/getqr/${url}`, { responseType: 'blob' })
        .then(response => {
          const blob = new Blob([response.data], { type: 'application/pdf' })
          const link = document.createElement('a')
          link.href = URL.createObjectURL(blob)
          link.download = label
          link.click()
          URL.revokeObjectURL(link.href)
        }).catch(console.error)
    },
    chargeData() {
      this.list({
        client_id: this.currentClient.id,
        page: this.currentPage,
        per_page: this.pageLength,
        search: this.searchTerm,
      })
    },
    handleSearch() {
      this.currentPage = 1
      this.appliedSearchTerm = this.searchTerm
      this.chargeData()
    },
    clearFilters() {
      this.searchTerm = ''
      this.appliedSearchTerm = ''
      this.currentPage = 1
      this.chargeData()
    },
    removeActiveFilter(idx) {
      const f = this.computedActiveFilters[idx]
      if (f && f.filterType === 'search') {
        this.appliedSearchTerm = ''
        this.searchTerm = ''
      }
      this.currentPage = 1
      this.chargeData()
    },
    toggleFilterSidebar() {
      this.showFilterSidebar = !this.showFilterSidebar
    },
    handleChangePage(page) {
      this.currentPage = page
      this.chargeData()
    },
    handlePageChange() {
      this.currentPage = 1
      this.chargeData()
    },
    deleteDepartment(id, name) {
      this.$bvModal
        .msgBoxConfirm(`¿Estás seguro de eliminar ${name}?`, {
          bodyClass: 'bodyDelete',
          footerClass: 'footerDelete',
          okVariant: 'danger',
          okTitle: 'Eliminar',
          cancelTitle: 'Cancelar',
          cancelVariant: 'outline-danger',
          centered: true,
        })
        .then(value => {
          if (value === true) {
            this.delete(id)
          }
        })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-good-table.scss'
</style>
